import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 10 * 60 * 1000, // 10 minutes - keep checking the chache by refetching after 30 minutes and comparing it with current data.
      cacheTime: 60 * 60 * 1000, // 1 hour - delete cahce after 1 hour, would refetch if needed
      refetchOnWindowFocus: true,
      retry: 1,
    },
  },
});
